import logoImageDesktop from '../assets/domee_logo.png';
import logoImageMobile from '../assets/domee_logo.png';
import brandImage from '../assets/biketribe-brandImage-1500.jpg';
// Using smart home illustration for OG/Twitter fallbacks
import facebookImage from '../assets/illustration.png';
import twitterImage from '../assets/illustration.png';

/////////////////////////////////////////////////////////
// This file contains configs that affect branding     //
// NOTE: these are just some of the relevant configs   //
// Most of the work happens in marketplaceDefaults.css //
// and in components.                                  //
/////////////////////////////////////////////////////////

// Note: These come from the branding asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeBranding func)

// Marketplace color.
// This is saved as CSS Property: --marketplaceColor in src/app.js
// Also --marketplaceColorDark and --marketplaceColorLight are generated from this one
// by adding +/- 10% to lightness.
export const marketplaceColor = '#1a2233'; // Deep blue for smart home marketplace

// Logo is used in Topbar on mobile and desktop, where height is the limiting factor.
// Therefore, we strongly suggest that your image file for desktop logo is in landscape!
//
// If you need to fine-tune the logo, the component is defined in src/components/Logo/Logo.js
// By default logo gets 24 pixels vertical space, but it could be wider (e.g. 180px)
// The default images are meant for retina displays and are therefore twice as big in actual dimensions
export const logoImageDesktopURL = logoImageDesktop;
export const logoImageMobileURL = logoImageMobile;

// The _logoSettings_ settings for the logo. Due to constraints in current Topbar, we only support 3 height variants
// at this point. There could be more height variants in the future and potentially other logo formats than 'image'.
// Note: logo image is always scaled and the limiting factor is height. However, there's also maximum width,
//       which is 370px in the Topbar. If the logo is wider than that, browser will scale it down.
export const logoSettings = {
  height: 36, // PNG logo - using 36px height for better visibility
  format: 'image',
};

// Subtitle text that appears below the logo in the navbar
// This provides additional branding context and can be customized per marketplace
export const logoSubtitle = 'Domotique & Maison connectée';

// brandImageURL is used as a background image on the "hero" section of several pages.
// Used on AuthenticationPage, EmailVerificationPage, PasswordRecoveryPage, PasswordResetPage etc.
// NOTE: Those pages use ResponsiveBackgroundImageContainer component,
//       it's possible to include more image variants to make image fetching more performant.
export const brandImageURL = brandImage;

// Default images for social media sharing
// These can be overwritten per page

// For Facebook/WhatsApp, the aspect ratio should be 1200x630 (otherwise, the image is cropped)
// TODO: Create a proper social sharing image with Neokasa branding at 1200x630px
// For now, using the logo which will be scaled by social media platforms
export const facebookImageURL = facebookImage;
// For Twitter, the aspect ratio should be 600x314 (otherwise, the image is cropped)
// TODO: Create a proper social sharing image with Neokasa branding at 600x314px
export const twitterImageURL = twitterImage;
